import React from 'react';
import { useTranslation } from 'react-i18next';
import { HomeTaskAttachments } from '@/components/HomeTaskModal/HomeTaskAttachments';
import { CommentChip } from '@/components/Icons/MarkChipIcons';
import { DETAILS_CARD } from '@/components/LessonDetailsModal/classNames';
import type { Attachment } from '@/types/attachment';
import type { TestReport } from '@/types/testReport';
import { sanitizeRichTextHtml } from '@/utils/html';

interface Props {
  report: TestReport;
  onPreview: (attachment: Attachment) => void;
}

export const TestReportSubjectCard: React.FC<Props> = ({
  report,
  onPreview,
}) => {
  const { t } = useTranslation();

  const { disciplineName, testSubject, testNotes } = report;

  return (
    <div className="flex flex-col gap-2">
      <div className={`flex flex-col gap-3 ${DETAILS_CARD}`}>
        <p className="text-callout-16 text-foreground">{disciplineName}</p>

        {!testSubject.text && (
          <p className="text-body-14 text-subtle-foreground">
            {t('diary.emptyDescription')}
          </p>
        )}
        {!!testSubject.text && (
          <div
            className="rich-text text-body-14 text-subtle-foreground"
            dangerouslySetInnerHTML={{
              __html: sanitizeRichTextHtml(testSubject.text),
            }}
          />
        )}

        <HomeTaskAttachments
          isFullWidth
          attachments={testSubject.attachments}
          onPreview={onPreview}
        />
      </div>

      {!!testNotes && (
        <div className={`flex items-center gap-2 ${DETAILS_CARD}`}>
          <CommentChip />
          <p className="text-body-14 min-w-0 flex-1 text-muted-foreground">
            {testNotes}
          </p>
        </div>
      )}
    </div>
  );
};
